import React from 'react';
import { Icon } from 'antd'
function Loader({ invert }) {
  return (
    <div style={{ minHeight: '300px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div>
        <Icon type="loading" style={invert ? { color: '#fff', fontSize: 50 } : { fontSize: 50 }} />
        <div style={invert ? { color: '#fff' } : {}}>Loading..</div>
      </div>
    </div>
  )
}

export default Loader;

Loader.defaultProps = {
  invert: false,
}


// WEBPACK FOOTER //
// ./src/components/Loader/index.js